export const WOOTRIC_ACCOUNT_TOKEN = 'NPS-2b1535ec'; // This is your unique account token.
export const WOOTRIC_SURVEY_IMMEDIATELY = true;
export const WOOTRIC_NO_SURVEYED_COOKIE = true;
